var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePayGMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 8.92199,
    height: 9.10022,
    viewBox: "0 0 8.92199 9.10022",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "G_Mark_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Blue_500",
    d: "M8.92196 4.65401C8.92196 4.32143 8.89217 4.0032 8.83685 3.69719H4.556V5.45038L7.02143 5.45091C6.92143 6.03424 6.59962 6.53151 6.10654 6.86302V8.00046H7.57409C8.431 7.20834 8.92196 6.03743 8.92196 4.65401Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Green_500_1_",
    d: "M6.10692 6.86305C5.69841 7.13825 5.17235 7.29922 4.55692 7.29922C3.36809 7.29922 2.35958 6.49913 1.99841 5.42066H0.48458V6.5937C1.23458 8.08019 2.77607 9.10022 4.55692 9.10022C5.78777 9.10022 6.82181 8.69593 7.57447 7.99996L6.10692 6.86305Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Yellow_500_1_",
    d: "M1.85587 4.55043C1.85587 4.2476 1.9064 3.95488 1.99842 3.67968V2.50664H0.484591C0.174485 3.12132 1.73462e-05 3.81515 1.73462e-05 4.55043C1.73462e-05 5.2857 0.175017 5.97954 0.484591 6.59421L1.99842 5.42117C1.9064 5.14598 1.85587 4.85325 1.85587 4.55043Z",
    fill: "#FABB05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Red_500",
    d: "M4.55692 1.80111C5.22873 1.80111 5.83032 2.03221 6.30532 2.48379L7.60586 1.1859C6.81596 0.451161 5.78618 0.000114428 4.55692 0.000114428C2.7766 0.000114428 1.23458 1.02015 0.48458 2.50663L1.99841 3.67967C2.35958 2.6012 3.36809 1.80111 4.55692 1.80111Z",
    fill: "#E94235"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePayGMark);
export default __webpack_public_path__ + "static/media/google-pay-g-mark.0c0b2bddbacf0a8d8ff606315437c8d0.svg";
export { ForwardRef as ReactComponent };